import React from "react";
import { Link } from "react-router-dom";

function ServiceIcon({ slug }) {
  const cls = "mx-auto text-gold";
  if (slug === "lash-extensions") {
    return (
      <svg className={cls} width="50" height="24" viewBox="0 0 64 30" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" aria-hidden="true">
        <path d="M4 12 C 18 24, 46 24, 60 12" />
        <path d="M13 18 L 10 28" />
        <path d="M23 22 L 22 29" />
        <path d="M32 23 L 32 30" />
        <path d="M41 22 L 42 29" />
        <path d="M51 18 L 54 28" />
      </svg>
    );
  }
  if (slug === "brow-services") {
    return (
      <svg className={cls} width="50" height="20" viewBox="0 0 64 24" fill="currentColor" aria-hidden="true">
        <path d="M3 17 C 18 5, 44 3, 61 9 C 45 9, 21 12, 5 21 C 4 20, 3 18, 3 17 Z" />
      </svg>
    );
  }
  // skin & beauty -> lotus
  return (
    <svg className={cls} width="44" height="28" viewBox="0 0 64 44" fill="currentColor" aria-hidden="true">
      <path d="M32 6 C 27 18, 27 27, 32 35 C 37 27, 37 18, 32 6 Z" />
      <path d="M32 35 C 23 31, 17 23, 17 14 C 26 18, 31 27, 32 35 Z" />
      <path d="M32 35 C 41 31, 47 23, 47 14 C 38 18, 33 27, 32 35 Z" />
      <path d="M32 35 C 19 35, 9 29, 5 21 C 16 23, 27 29, 32 35 Z" />
      <path d="M32 35 C 45 35, 55 29, 59 21 C 48 23, 37 29, 32 35 Z" />
    </svg>
  );
}

export default function ServiceCard({ service }) {
  const bookHref = service.bookAllCategories
    ? "/book"
    : `/book?category=${encodeURIComponent(service.acuityCategory)}`;
  return (
    <article className="group relative flex h-full flex-col overflow-hidden rounded-lg border border-gold/40 bg-onyx text-center">
      {/* Image fading into black */}
      <Link
        to={`/services/${service.slug}`}
        className="block overflow-hidden"
        aria-label={`${service.title} - view details`}
      >
        <img
          src={service.image}
          alt={service.alt}
          loading="lazy"
          decoding="async"
          className="block h-auto w-full object-contain transition-transform duration-700 group-hover:scale-[1.03]"
        />
      </Link>
      {/* Content below the full image */}
      <div className="flex flex-1 flex-col items-center px-2 pb-4 pt-3 sm:px-5 sm:pb-7 sm:pt-4">
        <ServiceIcon slug={service.slug} />
        <h3 className="mt-2 font-display text-sm uppercase leading-tight tracking-wide text-ivory sm:mt-3 sm:text-2xl md:text-[1.7rem]">
          <Link to={`/services/${service.slug}`} className="transition-colors hover:text-gold">
            {service.title}
          </Link>
        </h3>
        <p className="mt-1.5 text-[0.52rem] font-medium uppercase leading-relaxed tracking-[0.1em] text-gold sm:mt-2.5 sm:text-xs sm:tracking-[0.18em]">
          {service.tagline}
        </p>
        <div className="mt-auto w-full pt-3 sm:pt-5">
          <Link
            to={bookHref}
            className="btn-gold-outline inline-block px-4 py-1.5 text-[0.5rem] uppercase tracking-[0.16em] sm:px-8 sm:py-2.5 sm:text-[0.7rem] sm:tracking-[0.28em]"
          >
            Book Now
          </Link>
        </div>
      </div>
    </article>
  );
}
